export class ValidateDataCatalogPipelineResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "valid",
            "baseName": "valid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "violations",
            "baseName": "violations",
            "type": "Array<DataCatalogPipelineViolation>",
            "format": ""
        },
        {
            "name": "warnings",
            "baseName": "warnings",
            "type": "Array<DataCatalogPipelineViolation>",
            "format": ""
        },
        {
            "name": "definition",
            "baseName": "definition",
            "type": "DataCatalogPipelineDefinition",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValidateDataCatalogPipelineResponse.attributeTypeMap;
    }
    constructor() {
    }
}
